import i18n, { i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, I18N_NAMESPACES } from './constants';

let initialized = false;

export const getI18nInstance = (): I18nInstance => {
  if (!initialized) {
    i18n
      .use(HttpBackend)
      .use(initReactI18next)
      .init({
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: SUPPORTED_LOCALES,
        lng: DEFAULT_LOCALE,
        ns: I18N_NAMESPACES,
        defaultNS: 'common',
        fallbackNS: 'common',
        interpolation: {
          escapeValue: false,
        },
        backend: {
          loadPath: '/{{lng}}/{{ns}}.json',
        },
        react: {
          useSuspense: false,
        },
      })
      .catch((error) => {
        console.error('Failed to initialize i18next', error);
      });

    initialized = true;
  }

  return i18n;
};
